import { render, staticRenderFns } from "./PumaPromoCompanySelect.vue?vue&type=template&id=e22ca3be&"
import script from "./PumaPromoCompanySelect.vue?vue&type=script&lang=js&"
export * from "./PumaPromoCompanySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports